import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import { InsightsService } from '../service/insights.service';


@Component({
  selector: 'app-voc-intro-png',
  templateUrl: './voc-intro-png.component.html',
  styleUrls: ['./voc-intro-png.component.scss']
})
export class VocIntroPngComponent implements OnInit, AfterViewInit {
  @Output() dataEmitter: EventEmitter<Blob> = new EventEmitter<Blob>();
  // @Output() dataEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Input() introObj: any ={};
  @ViewChild("canvas") canvas: ElementRef;
  @ViewChild("downloadLink") downloadLink: ElementRef;
  public isShowScreen:boolean = true;
  capturedImage;
  constructor(public iService: InsightsService, private ngZone: NgZone) { }
  ngAfterViewInit(): void {
    this.capturedImageFromHtml()
    }

  ngOnInit(): void {
    // this.introObj = {"comments":"comment test 1","title":" Title test","list":["item 1","Item 2"]};
    this.isShowScreen = true;   
  }

  // capturedImageFromHtml() {
  //   html2canvas(document.querySelector("#capture")).then(canvas => {
  //     this.iService.vocScreenPng = [];
  //     canvas.toBlob((blob) => {
  //       if (blob) {
  //         // console.log("blob in component ===> ",blob)
  //         this.iService.vocScreenPng.push(blob);
  //         // this.uploadImage(blob);
  //         this.sendData()
  //       }
  //     }, 'image/png');

  //     // this.downloadImage(canvas);
  //   });
  // }

  capturedImageFromHtml() {
    this.ngZone.run(() => {
      html2canvas(document.querySelector("#capture")).then(canvas => {
        this.iService.vocScreenPng = [];
        canvas.toBlob((blob) => {
          if (blob) {
            // console.log("blob in component ===> ",blob)
            const file = new File([blob], 'voc_intro_screen.png', {
              type: 'image/png',
              lastModified: Date.now(),
            });
            this.iService.vocScreenPng.push(file);
            // console.log("files in vocScreenPng ===> ",this.iService.vocScreenPng)
            // this.uploadImage(blob);
            this.sendData()
          }
        }, 'image/png');
  
        // this.downloadImage(canvas);
      });
    });
  }


  sendData() {
    this.dataEmitter.emit();
  }

  downloadImage(canvas){
    this.canvas.nativeElement.src = canvas.toDataURL();
    this.downloadLink.nativeElement.href = canvas.toDataURL("image/png");
    this.downloadLink.nativeElement.download = "voc_screen.png";
    this.downloadLink.nativeElement.click();
    this.isShowScreen = false;
  }

}
